import { render } from "./ConsumerProductBasicInfo.vue?vue&type=template&id=d712793e"
import script from "./ConsumerProductBasicInfo.vue?vue&type=script&lang=js"
export * from "./ConsumerProductBasicInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__